import _defineProperty from "D:\\a\\1\\s\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import _Promise from "@babel/runtime-corejs3/core-js-stable/promise";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/includes";
import { JSON_CONTENT_TYPE, CONTENT_TYPE } from '../common';
export async function defaultErrorResponseHandler(response) {
  let message;
  const error = {
    status: response.status,
    statusText: response.statusText || '<none>'
  };
  const contentType = response.headers.get(CONTENT_TYPE);
  if (contentType) {
    if (_includesInstanceProperty(contentType).call(contentType, JSON_CONTENT_TYPE)) {
      message = await response.json();
    } else {
      message = {
        message: await response.text()
      };
    }
  }
  return _Promise.reject(_objectSpread({}, error, {}, message));
}